module.exports = __vendor;